export const obtenerSeccionUrl = ({path, index = 1}) => {

    let arr = path.split('/')
    return arr[index]
}